export { default, type ProductTileTemplateProps } from './ProductTileTemplate';
